export default {
    namespaced: true,
    state: {
        isHuman: false,
        user: null
    },
    actions: {
        loginUser({ commit }, userData) {
            // Retrieve userInfo and userTokens
            const userInfo = userData.account_info
            const userTokens = userData.tokens
            // Set user info
            commit('setUser', userInfo);
            // Store tokens in the sessionStorage
            sessionStorage.setItem('access-token', userTokens.access); 
            sessionStorage.setItem('refresh-token', userTokens.refresh); 
        }
    },
    mutations: {
        setIsHuman(state) {
            state.isHuman = true;
        },
        clearIsHuman(state) {
            state.isHuman = false;
        },
        setUser(state, userInfo) {
            state.user = userInfo;
        },
        clearUser(state) {
            state.user = null;
        }
    },
    getters: {
        isLoggedIn: state => !!state.user,
        firstName: state => state.user ? state.user.first_name : null,
        lastName: state => state.user ? state.user.last_name : null,
        email: state => state.user ? state.user.email : null,
        company: state => state.user ? state.user.company : null,
        country: state => state.user ? state.user.country : null
    }
};